import {WlFavoriteEvent} from "../../../common/ts/webcomponents/events/WlFavorite";
import {Snippet} from "../components/snippet/snippet";
import {EventBus} from "../../../common/ts/events/EventBus";
import {connect} from "../../../common/ts/connect";
import PageData from "../../../common/ts/PageData";
import PageGallery from "../../../common/ts/components/PageGallery";

const wlFavoriteComponentSelector = 'wl-favorite';
const eventBus = EventBus.getInstance();


(window as any).initPage = (pageData: PageData) => {
    initSnippet(pageData);
    connect(() => {
        const favoritesSubtitleNumberElement = document.querySelector('.js-favorites-subtitle-number');
        document.querySelectorAll(wlFavoriteComponentSelector).forEach((item) => {
            item.addEventListener(WlFavoriteEvent.type, (e) => {
                const event: WlFavoriteEvent = e as WlFavoriteEvent;
                if (!event.isSelected) {
                    const listingToDelete: string = event.listingId;
                    const listingElement = document.querySelector(`.listing[data-listingid="${listingToDelete}"]`);
                    listingElement?.classList.add('hidden');
                }
                if (favoritesSubtitleNumberElement) {
                    favoritesSubtitleNumberElement.textContent = event.currentFavorites.listings.size.toString();
                }
            });
        });
    });
}

function initSnippet(pageData: PageData) {
    new Snippet({
        pageViewId: pageData.pageViewId,
        search: "",
        getSimilarsEvent: (params) => null,
        eventBus: eventBus,
        // findIntent: pageData.findIntent,
    }).init();
    new PageGallery();
}